import { Col, Collapse, Row } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';
import DocumentTypesSelectField from '@/components/_common/DocumentTypesSelectField';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';

const MoreOptions: React.FC = () => {
  const { Panel } = Collapse;
  const intl = useIntl();

  return (
    <Col span={24}>
      <Collapse accordion>
        <Panel
          header={intl.formatMessage({
            id: 'movimentOsXFinancial.form.overview.moreOptions.title',
          })}
          key={1}
        >
          <Row gutter={[24, 24]}>
            <Col xs={12}>
              <FloatingFormItem
                name="employeesId"
                label={intl.formatMessage({
                  id: 'movimentOsXFinancial.form.overview.moreOptions.employees',
                })}
              >
                <EmployeesInfiniteSelectField allowClear />
              </FloatingFormItem>
            </Col>

            <Col xs={12}>
              <FloatingFormItem
                name="documentTypesIds"
                label={intl.formatMessage({
                  id: 'movimentOsXFinancial.form.overview.moreOptions.documentType',
                })}
              >
                <DocumentTypesSelectField mode="multiple" />
              </FloatingFormItem>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </Col>
  );
};

export default MoreOptions;
